import {sum} from 'ramda';

import {PersonnelOverviewItem} from '@dms/api/core';

export const getPersonnelOverviewTotal = (items: PersonnelOverviewItem[]): number =>
  sum(items.map((item) => item.activeCount));
